import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import type {RootState} from '../../store/types';
import type {AdvancedSearchItemsState} from './types';

const initialState: AdvancedSearchItemsState = {
  itemIds: [],
};

const advancedSearchItemsSlice = createSlice({
  name: 'advancedSearchItems',
  initialState,
  reducers: {
    advancedSearchItemsUpdated: (
      _state,
      action: PayloadAction<AdvancedSearchItemsState>,
    ) => {
      return action.payload;
    },
    advancedSearchItemsCleared: () => {
      return initialState;
    },
  },
});

export const {advancedSearchItemsUpdated, advancedSearchItemsCleared} =
  advancedSearchItemsSlice.actions;
export const selectAdvancedSearchItems = (state: RootState) =>
  state.advancedSearchItems;

export default advancedSearchItemsSlice;
